import { render, staticRenderFns } from "./NoIntegrationsBox.vue?vue&type=template&id=6d671829&scoped=true&"
import script from "./NoIntegrationsBox.vue?vue&type=script&lang=js&"
export * from "./NoIntegrationsBox.vue?vue&type=script&lang=js&"
import style0 from "./NoIntegrationsBox.vue?vue&type=style&index=0&id=6d671829&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d671829",
  null
  
)

export default component.exports